export enum RebillyTransactionType {
  Authorize = 'authorize',
  Sale = 'sale',
  ThreeDS = '3ds-authentication',
}
